function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import orderBy from 'lodash.orderby';
var sort = {
  data() {
    return {
      sortObject: {}
    };
  },

  mounted() {
    /**
     * Populate sorting object when the component mounted.
     * return an Object.
     */
    if (Array.isArray(this.headers) && this.headers.length) {
      return this.headers.map(header => {
        this.sortObject = _objectSpread(_objectSpread({}, this.sortObject), {}, {
          [header.key]: 'no-sort'
        });
      });
    }

    return this.sortObject = {};
  },

  methods: {
    /**
     * Check if the header is sortable.
     * return a Boolean.
     */
    isSortable(header) {
      var _header$sortable;

      return (_header$sortable = header.sortable) !== null && _header$sortable !== void 0 ? _header$sortable : false;
    },

    /**
     * Mutate `sortObject` object when sort button is clicked.
     * Emit an event with an object {`someKey`: "asc" | "desc" | "no-sort"}
     */
    onSort(key) {
      var sortBy = null;

      switch (this.sortObject[key]) {
        case 'asc':
          sortBy = 'desc';
          break;

        case 'desc':
          sortBy = 'no-sort';
          break;

        default:
          sortBy = 'asc';
          break;
      }

      var newObj = {};

      for (var obj in this.sortObject) {
        newObj[obj] = 'no-sort';
        newObj[key] = sortBy;
      }

      this.sortObject = _objectSpread({}, newObj);

      if (this.localSort) {
        this.onLocalSort(key);
      }

      this.$emit('change:sort', {
        [key]: this.sortObject[key]
      });
    },

    onLocalSort(key) {
      switch (this.sortObject[key]) {
        case 'asc':
          this.sortByAscendingOrder(key);
          break;

        case 'desc':
          this.sortByDescendingOrder(key);
          break;

        default:
          this.resetSort();
          break;
      }
    },

    sortByAscendingOrder(key) {
      this.mItems = orderBy(this.mItems, key, 'asc');
    },

    sortByDescendingOrder(key) {
      this.mItems = orderBy(this.mItems, key, 'desc');
    },

    /**
     * reset local data to original state.
     */
    resetSort() {
      this.mItems = JSON.parse(JSON.stringify(this.items));
    }

  }
};
export default sort;